"use strict";
/**
 * 用户信息
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cookie_1 = __importDefault(require("../cookie"));
var thisuser = undefined;
/**
 * 用户
 */
var user = {
    /**
     * 获取用户信息
     */
    get: function () {
        if (thisuser != undefined)
            return thisuser;
        if (cookie_1.default.get('ut') && cookie_1.default.get('ct') && cookie_1.default.get('uidal')) {
            thisuser = {
                id: cookie_1.default.get('uidal').substring(0, 16),
                nick: cookie_1.default.get('uidal').substring(16)
            };
        }
        else {
            thisuser = null;
        }
        return thisuser;
    },
    /**
     * 退出登录
     * @param  {function} 退出之后回调
     */
    logOut: function (callback) {
        var date = new Date();
        document.cookie = "pi=;path=/;domain=eastmoney.com;expires=" + date.toUTCString();
        document.cookie = "ct=;path=/;domain=eastmoney.com;expires=" + date.toUTCString();
        document.cookie = "ut=;path=/;domain=eastmoney.com;expires=" + date.toUTCString();
        document.cookie = "uidal=;path=/;domain=eastmoney.com;expires=" + date.toUTCString();
        if (callback) {
            callback();
        }
    },
    isLogin: function () {
        if (this.get()) {
            return true;
        }
        else {
            return false;
        }
    },
    /**
     * 跳转登录页面
     */
    goLoginPage: function () {
        self.location.href = "https://passport2.eastmoney.com/pub/login?backurl=".concat(encodeURIComponent(self.location.href));
    }
};
exports.default = user;
